import "./setupReact18Compat";
import React from "react";
import ReactDOM from "react-dom";
import WebFont from "webfontloader";
import { Provider } from "react-redux";
import { ThemeProvider2 } from "@ui-kit/components/index.es";

import { store } from "store";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

import "styles/main.scss";

import App from "App";

// El pipeline inyecta packageVersion-BuildNumber en window.appVersion en cada build.
// Compara con el valor guardado en localStorage para detectar actualizaciones de la app.
const APP_BUILD_KEY = "app_last_build_id";

function checkAndReloadOnNewBuild() {
    if (!window.appVersion) {
        return false;
    }
    const lastBuild = localStorage.getItem(APP_BUILD_KEY);
    if (!lastBuild) {
        localStorage.setItem(APP_BUILD_KEY, window.appVersion);
        return false;
    }
    if (lastBuild !== window.appVersion) {
        localStorage.setItem(APP_BUILD_KEY, window.appVersion);
        window.location.reload(true);
        return true;
    }
    return false;
}

/* eslint-disable react/jsx-filename-extension */
window.startApp = () => {
    // Se ejecuta después de deviceready: momento seguro para recargar en Cordova.
    // Si detecta build nueva, recarga y no renderiza para evitar estado inconsistente.
    if (checkAndReloadOnNewBuild()) {
        return;
    }
    ReactDOM.render(
        <Provider store={store}>
            <ThemeProvider2 isV3Layout={isUxDashboardImprovementsEnabled()}>
                <App />
            </ThemeProvider2>
        </Provider>,
        document.getElementById("root"),
    );
};
/* eslint-enable react/jsx-filename-extension */

// Phonegap app start in ondeviceready inside index.js
if (!window.cordova) {
    window.startApp();

    WebFont.load({
        google: {
            families: ["Montserrat:400,500,700", "sans-serif"],
        },
        custom: {
            families: [
                "Graphik-Thin",
                "Graphik-Light",
                "Graphik-Regular",
                "Graphik-Medium",
                "Graphik-Semibold",
                "Graphik-Bold",
            ],
            urls: ["../public/font/fonts.css"],
        },
    });
}
